module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_cocacola_04.523eee27.jpg";